import React from 'react';

import SectionBreakTitle, { SectionColor } from '../../SectionBreakTitle';
import ProArticleItem from './ProArticleItem';
import { ProArticlesProps } from './interfaces';

const ProArticles = ({ proArticles }: ProArticlesProps) => {
  return (
    <aside className="mt-48">
      <SectionBreakTitle
        title="Recent Pro articles"
        titleClassName="text-pro-gold"
        color={SectionColor.Gold}
      />
      <div className="flex flex-col justify-center py-32 sm:flex-row sm:gap-48 md:gap-56">
        {proArticles.map((article) => (
          <ProArticleItem key={article.id} article={article} />
        ))}
      </div>
    </aside>
  );
};

export default ProArticles;
